import { useNavigate } from 'react-router-dom';

import { ButtonBase, Typography } from '@mui/material';
import { useRecoilState } from 'recoil';

import { roleManager, roleOwner, roleViewer } from '@/router/consts';
import { sellerMap } from '@/router/managementMaps';
import { 매니저_라우터 } from '@/router/manager';
import { useUserAuth } from '@/state/cookieContext';
import { shopAuthContextState } from '@/state/userAuthContext';

/**
 * 로고 영역
 */
export default function LogoSection() {
  const [, setShopAuthContext] = useRecoilState(shopAuthContextState);
  const userAuth = useUserAuth();

  const navigate = useNavigate();

  const handleClick = () => {
    if (userAuth?.roles.includes(roleManager) || userAuth?.roles.includes(roleViewer)) {
      const url = 매니저_라우터['shop-list'].path;
      const managerShopAuth = {
        shopID: '',
        connectedPlatformTypes: [],
      };
      navigate(url, { replace: true });

      setShopAuthContext(managerShopAuth);
      return;
    }
    if (userAuth) {
      let url: string | undefined;

      if (userAuth.roles.includes(roleOwner)) {
        url = sellerMap['dashboard'].path;
      }

      if (url) {
        navigate(url);
      }
    }
  };

  return (
    <ButtonBase disableRipple onClick={handleClick}>
      <Typography fontWeight={'bold'} variant={'H1_Looko'}>
        Looko AI
      </Typography>
    </ButtonBase>
  );
}
